export const defaultProps = {
  easing: "cubic-bezier(0.5, 0, 0, 1)",
  distance: "30px",
  duration: 1000,
  desktop: true,
  mobile: true,
};

export const targetElements = [
  {
    element: ".section-title",
    animation: {
      delay: 200,
      distance: "0px",
      origin: "bottom",
    },
  },
  {
    element: ".hero-title",
    animation: {
      delay: 300,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".social-links",
    animation: {
      delay: 500,
      origin: window.innerWidth > 768 ? "right" : "bottom",
    },
  },
  {
    element: ".hero-cta",
    animation: {
      delay: 750,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".about-wrapper__image",
    animation: {
      delay: 500,
      origin: "bottom",
    },
  },
  {
    element: ".about-wrapper__info",
    animation: {
      delay: 750,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".project-wrapper__text",
    animation: {
      delay: 1000,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".project-wrapper__image",
    animation: {
      delay: 500,
      origin: window.innerWidth > 768 ? "right" : "bottom",
    },
  },
  {
    element: ".review-carousel",
    animation: {
      delay: 500,
      origin: window.innerWidth > 768 ? "left" : "bottom",
      distance: "30px",
    },
  },
  {
    element: ".contact-wrapper",
    animation: {
      delay: 750,
      origin: "bottom",
    },
  },
    {
    element: ".steps-wrapper",
    animation: {
      delay: 500,
      origin: "bottom",
    },
  },
];
